import MarkdownIt from "markdown-it";
import DOMPurify from "dompurify";

const md = new MarkdownIt({
    breaks: true,
    linkify: true
});

const markdown = {

    install(app) {
        app.config.globalProperties.$markdown = markdown
    },

    render(value) {
        return DOMPurify.sanitize(md.render(value || ""));
    }
}

export default markdown